'use strict';

const getVehiclePicker = () =>
	import(/* webpackChunkName: "get-vehicle-picker" */ 'public/js/components/vehicle-picker.js');

/**
 * @param {unknown} value
 * @returns {value is Record<string, unknown>}
 */
function isPlainObject(value) {
	return value !== null && typeof value === 'object' && !Array.isArray(value);
}

/**
 * @param {unknown} detail
 * @returns {Record<string, unknown>}
 */
function normalizeSteerDetail(detail) {
	if (!isPlainObject(detail)) {
		return {};
	}

	return detail;
}

/**
 * @param {string} ga4EventName
 * @param {Record<string, unknown>} context
 */
function trackSteerInboundEvent(ga4EventName, context) {
	const track = globalThis.rp_app?.track;
	if (typeof track?.track_ec_general !== 'function') {
		return;
	}

	track.track_ec_general(ga4EventName, {
		...context,
		source: 'steer',
	});
}

function openVehiclePickerFresh() {
	getVehiclePicker()
		.then((module) => {
			module.getDataAndOpenVehiclePicker({ navigateAfterSelect: false });
		})
		.catch((error) => {
			globalThis.rp_app?.logger?.error({
				message: 'Failed to open vehicle picker from STEER event',
				error,
				listener: 'steer-inbound',
			});
		});
}

/**
 * @param {Record<string, unknown>} context
 */
function handleVehiclePickerInitialize(context) {
	trackSteerInboundEvent('vehicle_picker_initialize', context);
	openVehiclePickerFresh();
}

/** @type {Record<string, (context: Record<string, unknown>) => void>} */
const STEER_INBOUND_HANDLERS = {
	'vehicle-picker-initialize': handleVehiclePickerInitialize,
};

function registerSteerInboundListeners() {
	Object.entries(STEER_INBOUND_HANDLERS).forEach(([eventName, handler]) => {
		globalThis.addEventListener(eventName, (event) => {
			handler(normalizeSteerDetail(event.detail));
		});
	});
}

module.exports = {
	STEER_INBOUND_HANDLERS,
	handleVehiclePickerInitialize,
	normalizeSteerDetail,
	openVehiclePickerFresh,
	registerSteerInboundListeners,
	trackSteerInboundEvent,
};
